export const getCountriesFromState = (state) => state.countries.countries;
export const getLanguageFromState = (state) => state.language.language;
export const getSearchFromState = (state) => state.search.search;
